import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';
import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';
import WrapperPublic from 'components/wrappers/Public';

import SectionContent from './sections/Content';
import SectionNewsletter from './sections/Newsletter';
import StyledComponent from './styles';
import { Props } from './types';

const PageRegulations: NextPage<Props> = ({ pageTranslations }) => {
    const sections: PageSection[] = useMemo(() => [{
        slug: 'content',
        order: 1,
        isVisible: true,
        children: (slug, translations) => (
            <SectionContent
                key={slug}
                translations={translations}
            />
        ),
    }, {
        slug: 'newsletter',
        order: 2,
        isVisible: true,
        children: (slug, translations) => (
            <SectionNewsletter
                key={slug}
                translations={translations}
            />
        ),
    }], []);

    return (
        <WrapperPublic>
            <StyledComponent className="page-regulations">
                <Head
                    title={pageTranslations?.page?.metaTitle}
                    description={pageTranslations?.page?.metaDescription}
                    canonical={withVariables(Routes.PublicHome)}
                />
                <PageContainer>
                    <SectionsWrapper
                        sections={sections}
                        localTranslations={pageTranslations?.sections}
                        enabledStates={pageTranslations?.sectionsEnabled}
                    />
                </PageContainer>
            </StyledComponent>
        </WrapperPublic>
    );
};

export default PageRegulations;
